/* BachatBazaar Marketplace — Interactive JS */
(function () {
  'use strict';

  /* ---- Hero carousel auto-rotation ---- */
  function initCarousels() {
    document.querySelectorAll('[data-bb-carousel]').forEach(function (stage) {
      var sectionId = stage.dataset.bbCarousel;
      var dots = document.querySelector('[data-bb-dots="' + sectionId + '"]');
      var slides = stage.querySelectorAll('.bb-slide');
      var n = slides.length;
      if (n < 2) return;
      var idx = 0;

      function goTo(i) {
        idx = i;
        stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
        syncDots(i);
      }

      function syncDots(i) {
        if (!dots) return;
        [].forEach.call(dots.children, function (d, j) {
          d.classList.toggle('on', j === i);
        });
      }

      stage.addEventListener('scroll', function () {
        var i = Math.round(stage.scrollLeft / (stage.clientWidth || 1));
        syncDots(i);
      }, { passive: true });

      setInterval(function () { goTo((idx + 1) % n); }, 4200);
    });
  }

  /* ---- Countdown timers ---- */
  function initCountdowns() {
    document.querySelectorAll('[data-bb-countdown]').forEach(function (el) {
      var hours = parseInt(el.dataset.bbCountdown || 4, 10);
      var end = Date.now() + (hours * 3600 + 59 * 60 + 59) * 1000;
      var th = el.querySelector('[data-h]');
      var tm = el.querySelector('[data-m]');
      var ts = el.querySelector('[data-s]');

      function tick() {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (th) th.textContent = String(Math.floor(s / 3600)).padStart(2, '0');
        if (tm) tm.textContent = String(Math.floor(s / 60) % 60).padStart(2, '0');
        if (ts) ts.textContent = String(s % 60).padStart(2, '0');
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---- Add-to-cart button feedback ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bb-pcard__atc[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        /* Update cart count bubble if Dawn's pubsub is available */
        if (window.PubSub) {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              window.PubSub.publish('cart:refresh', { source: 'bb-marketplace' });
            });
        }
        setTimeout(function () {
          btn.textContent = orig;
          btn.disabled = false;
        }, 1400);
      })
      .catch(function () {
        btn.textContent = orig;
        btn.disabled = false;
      });
  });

  /* ---- Boot ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCarousels();
      initCountdowns();
    });
  } else {
    initCarousels();
    initCountdowns();
  }
})();
